import { mysqlTable, varchar, text, int, timestamp, json, index, uniqueIndex } from "drizzle-orm/mysql-core";
import type { HeadphoneCheckout, HeadphoneQuote } from "../shared/headphoneCheckout";

export const headphoneOrders = mysqlTable("website_headphone_orders", {
  id: varchar("id", { length: 36 }).primaryKey(), tokenHash: varchar("tokenHash", { length: 64 }).notNull(),
  inputHash: varchar("inputHash", { length: 64 }).notNull(), customerId: int("customerId"),
  snapshot: json("snapshot").$type<Omit<HeadphoneCheckout, "token">>().notNull(),
  quote: json("quote").$type<HeadphoneQuote>().notNull(),
  state: varchar("state", { length: 24 }).notNull().default("new"),
  paymentRequestId: varchar("paymentRequestId", { length: 128 }), paymentUrl: text("paymentUrl"),
  paymentId: varchar("paymentId", { length: 128 }), paidAt: timestamp("paidAt"),
  adminEmail: varchar("adminEmail", { length: 20 }).notNull().default("pending"),
  customerEmail: varchar("customerEmail", { length: 20 }).notNull().default("pending"),
  error: text("error"), createdAt: timestamp("createdAt").defaultNow().notNull(),
  updatedAt: timestamp("updatedAt").defaultNow().onUpdateNow().notNull(),
}, t => ({ request: uniqueIndex("headphone_payment_request").on(t.paymentRequestId),
  payment: uniqueIndex("headphone_payment").on(t.paymentId), state: index("headphone_state").on(t.state),
  customer: index("headphone_customer").on(t.customerId) }));
export const headphoneIdentityLocks = mysqlTable("website_headphone_identity_locks", {
  id: varchar("id", { length: 64 }).primaryKey(),
});
